import type React from 'react';
import styles from './Button.module.css';

export interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'ghost' | 'icon';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  title?: string;
  leftIcon?: React.ReactNode;
  disabled?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  variant = 'primary',
  size = 'md',
  className = '',
  title,
  leftIcon,
  disabled = false,
}) => {
  const buttonStyle = styles[variant] || styles.primary;
  const sizeStyle = styles[size] || styles.md;
  const isIconOnly = variant === 'icon';

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`${styles.button} ${buttonStyle} ${sizeStyle} ${className}`}
      title={title}
    >
      {isIconOnly ? (
        children
      ) : (
        <>
          {leftIcon && <span className={styles.leftIcon}>{leftIcon}</span>}
          {children}
        </>
      )}
    </button>
  );
};
